import { render, staticRenderFns } from "./TranslationTest.vue?vue&type=template&id=bb8697a0&"
import script from "./TranslationTest.vue?vue&type=script&lang=js&"
export * from "./TranslationTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/common/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Ftranslation%2FTranslationTest.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./TranslationTest.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports